import { useContext } from 'react';
import { useQueries } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { RequestedFolder } from '../components/dataManagement/DataManagement';
import { mapToFolderListViewModel } from './mappers/folder';
import { ListFoldersInput, ListFoldersPayload } from './generated/types';

const query = `query ListFolders($input: ListFoldersInput!) {
    listFolders(input: $input) {
      subfolders {
        id
        name
      }
    }
  }`;

export const useListFolders = (requestedFolders: Array<RequestedFolder>) => {
    const context = useContext(AppContext);
    return useQueries({
        queries: requestedFolders.map((parent: RequestedFolder) => {
            return ({
                queryKey: ['listFolders', parent.id],
                queryFn: async () => {

                    const input: ListFoldersInput = {
                        parentFolderId: parent.id,
                    };

                    const response = await (context.api.graphql({
                        query,
                        variables: { input },
                    }) as Promise<{ data: { listFolders: ListFoldersPayload } }>);

                    return {
                        parentFolderId: parent.id,
                        folders: mapToFolderListViewModel(response.data.listFolders!.subfolders!, parent.level + 1, parent.id),
                    };
                },
            }
            );
        }),
    });
};
